"use client";

import { forwardRef } from "react";
import { cn } from "../../lib/utils";
import { Logo } from "./Logo";
import { HeaderProps } from "./types";
import { HEADER_STYLES } from "./constants";

const Header = forwardRef<HTMLElement, HeaderProps>(
  (
    {
      className,
      containerClassName,
      logoClassName,
      centerClassName,
      navClassName,
      actionsClassName,
      logo = <Logo />,
      center,
      nav,
      actions,
      ...props
    },
    ref
  ) => {
    return (
      <header
        ref={ref}
        className={cn(HEADER_STYLES.root, className)}
        {...props}
      >
        <div className={cn(HEADER_STYLES.container, containerClassName)}>
          <div className={cn(HEADER_STYLES.logoContainer, logoClassName)}>{logo}</div>
          {center && (
            <div className={cn(HEADER_STYLES.centerContainer, centerClassName)}>
              {center}
            </div>
          )}
          {nav ? (
            <div className={HEADER_STYLES.trailingContainer}>
              <div className={cn(HEADER_STYLES.navContainer, navClassName)}>{nav}</div>
              <div className={cn(HEADER_STYLES.actionsContainer, actionsClassName)}>{actions}</div>
            </div>
          ) : (
            <div className={cn(HEADER_STYLES.actionsContainer, actionsClassName)}>{actions}</div>
          )}
        </div>
      </header>
    );
  }
);

Header.displayName = "Header";

export { Header };
